import {CloseCircleFilled} from "@ant-design/icons";
import { useState, useMemo, useEffect } from "react";
import useBenefitGroups from '../../shared/hooks/useBenefitGroups';
import { AutoComplete } from "antd";
import {DEFAULT_PAGE_SIZE} from '../../shared/constants/query';
import { useTranslation } from "react-i18next";

const {Option} = AutoComplete;

const GroupSelector = ({
    onGroupSelectHandler = null, 
    onGroupClearHandler = null, 
    onGroupChangeHandler = null,
    onGroupResultsHandler = null
}) => {
    const {searchResults, searchGroup, alphabeticalSort} = useBenefitGroups();
    const {t} = useTranslation();
    const [searchTimer, setSearchTimer] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [updatedResults, setUpdatedResults] = useState(false);

    const searchResultsOrdered = useMemo(()=>{
        if(searchResults === null){
            return [];
        } else {
            return searchResults?.content.sort(alphabeticalSort) ?? [];
        }
    },[searchResults, alphabeticalSort]);

    const searchOptions = useMemo(()=>{
        if(searchResultsOrdered === null){
            return [];
        } else {
            return searchResultsOrdered.map(item => <Option key={item.benefitGroupId} value={item.benefitGroupId}>{item.description}</Option>)
        }
    },[searchResultsOrdered]);

    useEffect(()=> {
        if(updatedResults) {
            if(onGroupResultsHandler !== null) {
                const results = searchResults !== null ? {
                    content: searchResultsOrdered,
                    pagination: {... searchResults.pagination ?? null}
                } : null;
                onGroupResultsHandler(results);
            }
            setUpdatedResults(false); 
        }
    },[searchResults, searchResultsOrdered, onGroupResultsHandler])

    const onGroupChange = (text) => {
        const wasSelected = searchResultsOrdered.some(item => item.benefitGroupId === text);
        const wasEmpty = text && text.length < 0 ? true : false;
        if(!wasSelected || wasEmpty) {
            setSearchValue(text);
            clearTimeout(searchTimer);
            const timer = setTimeout(() => {
                searchGroup(text, 1, DEFAULT_PAGE_SIZE, () => {
                    setUpdatedResults(true); 
                });
            }, 500);
            setSearchTimer(timer);    
            if(onGroupChangeHandler !== null){
                onGroupChangeHandler(text);
            };
        }

    };

    const onGroupSelect = (value) => {
        const result = searchResultsOrdered.find(item => item.benefitGroupId === value);
        if(result){
            setSearchValue(result.description);
            if(onGroupSelectHandler !== null){
                onGroupSelectHandler(result);
            };
        }else{
            defaultGroupClear(); 
        }
    }

    const defaultGroupClear = () => {
        setSearchValue(null);
    }

    const onGroupClear = () => {
        defaultGroupClear(); 
        if(onGroupClearHandler !== null){
            onGroupClearHandler();
        }
    }

    return (
        <AutoComplete
            value={searchValue}
            placeholder={t('benefitsExampleLbl')}
            onChange={(text) => onGroupChange(text)} 
            allowClear={{
                clearIcon: <CloseCircleFilled />,
            }}
            className='fullWidth'
            onSelect={(value) => onGroupSelect(value)}
            onClear={() => onGroupClear()}
        >
            {searchOptions}    
        </AutoComplete>
    )
}

export default GroupSelector;